import type { RouteLocationNormalized } from 'vue-router';
import { routenames } from '../routenames';
import { useAccountStore } from '@/stores/accountStore';

export async function eulaGuard(to: RouteLocationNormalized) {
  const { currentUser } = useAccountStore();

  const needsEulaAcceptance = currentUser !== undefined && !currentUser.eulaAccepted;

  if (needsEulaAcceptance && !to.meta.noAuthRequired) {
    return {
      name: routenames.eula,
    };
  }
}
